import AddConfigurationForm  from '../components/Forms/AddConfigurationForm';

function AddConfigurationPage() {
    
    return <section style={{margin: "20px"}}>
        <h1>Add a Configuration</h1>

        <AddConfigurationForm />
    </section>
}

export default AddConfigurationPage;